(() => {
  const init = (section) => {
    if (section.dataset.comparisonsReady) return;
    section.dataset.comparisonsReady = 'true';
    const track = section.querySelector('[data-nb-comparison-track]');
    const cards = [...track.querySelectorAll('[data-nb-comparison-card]')];
    const prev = section.querySelector('[data-nb-comparison-prev]');
    const next = section.querySelector('[data-nb-comparison-next]');
    const status = section.querySelector('[data-nb-comparison-status]');
    if (!cards.length) return;
    const stableCards = !!section.closest('.nbp-compact[data-nb-shape-page]');
    const position = () => cards.reduce((best, card, i) => Math.abs(card.offsetLeft - cards[0].offsetLeft - track.scrollLeft) < Math.abs(cards[best].offsetLeft - cards[0].offsetLeft - track.scrollLeft) ? i : best, 0);
    const update = () => {
      const i = position();
      const viewport = track.getBoundingClientRect();
      const visible = cards.filter(card => { const box = card.getBoundingClientRect(); return box.right > viewport.left + 1 && box.left < viewport.right - 1; });
      if (!stableCards && visible.length) track.style.height = Math.ceil(Math.max(...visible.map(card => card.getBoundingClientRect().height)) + 16) + 'px';
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      status.textContent = (i + 1) + ' / ' + cards.length;
    };
    const move = (i) => {
      const card = cards[Math.max(0, Math.min(cards.length - 1, i))];
      track.scrollTo({left: card.offsetLeft - cards[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    };
    prev.addEventListener('click', () => move(position() - 1));
    next.addEventListener('click', () => move(position() + 1));
    track.addEventListener('keydown', (event) => {
      if (event.target !== track) return;
      if (event.key === 'ArrowRight') { event.preventDefault(); move(position() + 1); }
      else if (event.key === 'ArrowLeft') { event.preventDefault(); move(position() - 1); }
      else if (event.key === 'Home') { event.preventDefault(); move(0); }
      else if (event.key === 'End') { event.preventDefault(); move(cards.length - 1); }
    });
    track.addEventListener('scroll', update, {passive:true});
    if (!stableCards) {
      const observer = new ResizeObserver(update);
      observer.observe(track);
      cards.forEach(card => observer.observe(card));
      track.querySelectorAll('img').forEach(image => image.addEventListener('load', update));
    }
    update();
  };
  const scan = () => document.querySelectorAll('[data-nb-comparisons]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
